module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-97-100-normal.705b871.woff2";